"use client";

import { useSyncExternalStore } from "react";
import { isTrackingAllowed } from "./privacy";

const subscribe = (notify: () => void) => {
  window.addEventListener("consent_update", notify);
  return () => window.removeEventListener("consent_update", notify);
};

export function useTrackingConsent(): boolean {
  return useSyncExternalStore(subscribe, isTrackingAllowed, () => false);
}
